<template>
  <div class="main_body">
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <button
      class="btn btn-primary btn-sm"
      data-bs-toggle="modal"
      data-bs-target="#AddNewChannelModal"
      style="float: right"
    >
      Add Channel
    </button>
    <div class="container-fluid">
      <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-3">
        <div
          v-for="(channel, index) in channelAllData"
          :key="index"
          class="col"
        >
          <div
            v-on:click="navigate(channel.id)"
            class="card main_dashboard_card shadow border-0"
          >
            <div class="d-flex flex-column flex-md-row">
              <div class="align-self-center text-center">
                <img v-bind:src="channel.image_url" class="img-fluid profileImage" />
              </div>
              <div class="ps-0 ps-md-2 ps-lg-3">
                <p class="m-0 text-center text-md-start text-white">
                  {{channel.name}}
                </p>
                <h5 class="mb-0 text-center text-md-start text-white fw-bold">
                  test data
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CreateChannelModal />
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import CreateChannelModal from "./CreateChannelModal";

export default {
  components: { CreateChannelModal, Loading  },
  data() {
    return {
      channelAllData: [],
      id: localStorage.getItem(this.$idKey),
      publisherid: localStorage.getItem(this.$publisherId),
       //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars"
    };
  },
  methods: {
    navigate(id) {
      this.$router.push("/channel-details/" + id);
    },
    async getAll() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/channels/admin/get-by-publisher" +
            "?publisher_id=" +
            this.publisherid,

          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          this.channelAllData = res.data;
          console.log(res);
          console.log(this.channelAllData);
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.getAll();
  },
};
</script>
<style scoped>
.profileImage {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>